import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TherapistRegister from "../pages/therapist-register/page";
import SpaRegister from "../pages/SpaRegister";

/* ── Terapist Paneli ── */
import TherapistDashboard from "../pages/therapist-panel/dashboard/page";
import TherapistProfilim from "../pages/therapist-panel/profilim/page";
import TherapistGorunurluk from "../pages/therapist-panel/gorunurluk/page";
import TherapistFirsatlar from "../pages/therapist-panel/firsatlar/page";
import TherapistTalepler from "../pages/therapist-panel/talepler/page";
import TherapistGorusmeler from "../pages/therapist-panel/gorusmeler/page";
import TherapistFavoriler from "../pages/therapist-panel/favoriler/page";
import TherapistGecmis from "../pages/therapist-panel/gecmis/page";

/* Placeholder ayar sayfaları */
import TherapistBildirim from "../pages/therapist-panel/bildirim/page";
import TherapistDestek from "../pages/therapist-panel/destek/page";
import TherapistHesap from "../pages/therapist-panel/hesap/page";
import ChatDetail from "../pages/therapist-panel/chat/page";
import TherapistNotlarim from "../pages/therapist-panel/notlarim/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/terapist-kayit",
    element: <TherapistRegister />,
  },
  {
    path: "/spa-kayit",
    element: <SpaRegister />,
  },
  /* Terapist Paneli */
  {
    path: "/terapist-panel/dashboard",
    element: <TherapistDashboard />,
  },
  {
    path: "/terapist-panel/profilim",
    element: <TherapistProfilim />,
  },
  {
    path: "/terapist-panel/gorunurluk",
    element: <TherapistGorunurluk />,
  },
  {
    path: "/terapist-panel/firsatlar",
    element: <TherapistFirsatlar />,
  },
  {
    path: "/terapist-panel/talepler",
    element: <TherapistTalepler />,
  },
  {
    path: "/terapist-panel/gorusmeler",
    element: <TherapistGorusmeler />,
  },
  {
    path: "/terapist-panel/gorusmeler/:id",
    element: <ChatDetail />,
  },
  {
    path: "/terapist-panel/favoriler",
    element: <TherapistFavoriler />,
  },
  {
    path: "/terapist-panel/gecmis",
    element: <TherapistGecmis />,
  },
  {
    path: "/terapist-panel/bildirim-ayarlari",
    element: <TherapistBildirim />,
  },
  {
    path: "/terapist-panel/destek",
    element: <TherapistDestek />,
  },
  {
    path: "/terapist-panel/hesap",
    element: <TherapistHesap />,
  },
  {
    path: "/terapist-panel/notlarim",
    element: <TherapistNotlarim />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;